import { useEffect } from 'react';
import { LANDING_DESCRIPTION, LANDING_TITLE } from './constants';
import { LOGO_SRC, WEBSITE_URL } from '../../Shared/branding';

const OG_IMAGE = `${WEBSITE_URL}${LOGO_SRC}`;

const upsertMeta = (selector, attributes) => {
	let element = document.querySelector(selector);
	if (!element) {
		element = document.createElement('meta');
		document.head.appendChild(element);
	}
	const previous = {};
	Object.entries(attributes).forEach(([key, value]) => {
		previous[key] = element.getAttribute(key);
		element.setAttribute(key, value);
	});
	return { element, previous };
};

const LandingHead = () => {
	useEffect(() => {
		const previousTitle = document.title;
		document.title = LANDING_TITLE;

		const descriptionMeta = upsertMeta('meta[name="description"]', {
			name: 'description',
			content: LANDING_DESCRIPTION,
		});
		const ogTitle = upsertMeta('meta[property="og:title"]', {
			property: 'og:title',
			content: LANDING_TITLE,
		});
		const ogDescription = upsertMeta('meta[property="og:description"]', {
			property: 'og:description',
			content: LANDING_DESCRIPTION,
		});
		const ogType = upsertMeta('meta[property="og:type"]', {
			property: 'og:type',
			content: 'website',
		});
		const ogUrl = upsertMeta('meta[property="og:url"]', {
			property: 'og:url',
			content: WEBSITE_URL,
		});
		const ogImage = upsertMeta('meta[property="og:image"]', {
			property: 'og:image',
			content: OG_IMAGE,
		});
		const twitterCard = upsertMeta('meta[name="twitter:card"]', {
			name: 'twitter:card',
			content: 'summary',
		});
		const twitterTitle = upsertMeta('meta[name="twitter:title"]', {
			name: 'twitter:title',
			content: LANDING_TITLE,
		});
		const twitterDescription = upsertMeta('meta[name="twitter:description"]', {
			name: 'twitter:description',
			content: LANDING_DESCRIPTION,
		});
		const canonical = document.querySelector('link[rel="canonical"]');
		const previousCanonical = canonical?.getAttribute('href') ?? null;
		if (canonical) {
			canonical.setAttribute('href', WEBSITE_URL);
		}

		return () => {
			document.title = previousTitle;
			if (canonical) {
				if (previousCanonical == null) {
					canonical.removeAttribute('href');
				} else {
					canonical.setAttribute('href', previousCanonical);
				}
			}
			[
				descriptionMeta,
				ogTitle,
				ogDescription,
				ogType,
				ogUrl,
				ogImage,
				twitterCard,
				twitterTitle,
				twitterDescription,
			].forEach(({ element, previous }) => {
				Object.entries(previous).forEach(([key, value]) => {
					if (value == null) {
						element.removeAttribute(key);
					} else {
						element.setAttribute(key, value);
					}
				});
			});
		};
	}, []);

	return null;
};

export default LandingHead;
